import { MEDIA } from "@brg/ui";
import { LayoutConst } from "core";
import { BTagsGrid } from "core/components";
import styled from "styled-components";

const OFFSET_TO_SCROLL_BAR = 5

export const DesignerTagsContainer = styled.div`
    display: block;
    max-height: 106px;
    height: auto;
    overflow: hidden auto;

    .designer-tags-container {
        max-width: ${LayoutConst.projectCard.l.w - OFFSET_TO_SCROLL_BAR + 'px'};
        * {
            font-size: 15px;
            line-height: 20px;
            margin-bottom: 8px !important;
            padding: 4px 16px;
        }
    }

    * {
        font-size: 15px;
        line-height: 20px;
    }

    ::-webkit-scrollbar {
        width: 3px; /* ширина scrollbar */
        height: 10px;
    }
    ::-webkit-scrollbar-track {
        background: transparent; /* цвет дорожки */
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 10px; /* закругления плашки */
        background-color: ${({ theme }) => theme.scroll.bg};
    }

    @media${MEDIA.LAPTOP} {
        max-height: 94px;
        .designer-tags-container {
            max-width: ${LayoutConst.projectCard.l.w - OFFSET_TO_SCROLL_BAR + 'px'};
            * {
                font-size: 13px;
                line-height: 16px;
                margin-bottom: 8px !important;
                padding: 4px 16px;
            }
        }
    }


    @media${MEDIA.TABLET} {
        max-height: 86px;
        .designer-tags-container {
            max-width: ${LayoutConst.projectCard.s.w - OFFSET_TO_SCROLL_BAR + 'px'};
        }
    }

    @media${MEDIA.MOBILE} {
        max-height: 77px;
        .designer-tags-container {
            max-width:calc(50vw - 15px);
        }
    }


`;import { MEDIA } from "@brg/ui";
import { LayoutConst } from "core";
import { BTagsGrid } from "core/components";
import styled from "styled-components";

const OFFSET_TO_SCROLL_BAR = 5

export const DesignerTagsContainer = styled.div`
    display: block;
    max-height: 106px;
    height: auto;
    overflow: hidden auto;

    .designer-tags-container {
        max-width: ${LayoutConst.projectCard.l.w - OFFSET_TO_SCROLL_BAR + 'px'};
        * {
            font-size: 15px;
            line-height: 20px;
            margin-bottom: 8px !important;
            padding: 4px 16px;
        }
    }

    * {
        font-size: 15px;
        line-height: 20px;
    }

    ::-webkit-scrollbar {
        width: 3px; /* ширина scrollbar */
        height: 10px;
    }
    ::-webkit-scrollbar-track {
        background: transparent; /* цвет дорожки */
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 10px; /* закругления плашки */
        background-color: ${({ theme }) => theme.scroll.bg};
    }

    @media${MEDIA.LAPTOP} {
        max-height: 94px;
        .designer-tags-container {
            max-width: ${LayoutConst.projectCard.l.w - OFFSET_TO_SCROLL_BAR + 'px'};
            * {
                font-size: 13px;
                line-height: 16px;
                margin-bottom: 8px !important;
                padding: 4px 16px;
            }
        }
    }


    @media${MEDIA.TABLET} {
        max-height: 86px;
        .designer-tags-container {
            max-width: ${LayoutConst.projectCard.s.w - OFFSET_TO_SCROLL_BAR + 'px'};
        }
    }

    @media${MEDIA.MOBILE} {
        max-height: 77px;
        .designer-tags-container {
            max-width:calc(50vw - 15px);
        }
    }


`;